import RankProgress from "./RankProgress";

interface RightRankingCardProps {
    pointData?: {
        wallet: number;
        wallet_use: number;
        point_balance: number;
        point_total: number;
        level: string;
        level_avatar: string;
        next_level: string;
        next_level_avatar: string;
        percent: number;
    };
    pointTotal?: number;
    currentLevel?: string;
    nextLevel?: string;
    percent?: number;
    levelImage?: string;
    nextLevelImage?: string;

}

export default function RightRankingCard({
    pointData,
    pointTotal = 0,
    currentLevel = "",
    nextLevel = "",
    percent = 0,
    levelImage = "",
    nextLevelImage = "",
}: RightRankingCardProps) {
    return (
        <div className="MuiPaper-root styles_headingRight__EaPSD MuiPaper-elevation1 MuiPaper-rounded">
            <div className="MuiGrid-root MuiGrid-container MuiGrid-item">
                <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-5">
                    <p className="MuiTypography-root styles_titleRanking__5Or_5 MuiTypography-body1">
                        Điểm xếp hạng
                    </p>
                </div>

                <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-justify-content-xs-flex-end MuiGrid-grid-xs-7">
                    <p className="MuiTypography-root styles_datePoint__0p4Q2 MuiTypography-body1">
                        Tính từ 01/11/2025 - Hôm nay
                    </p>
                </div>
            </div>

            <RankProgress percent={percent} pointTotal={pointTotal} level={currentLevel} nextLevel={nextLevel} levelImage={levelImage} nextLevelImage={nextLevelImage} />

            <div
                className="MuiGrid-root styles_rankPoint__eH6Ky MuiGrid-item MuiGrid-grid-xs-12"
                style={{ marginTop: "16px" }}
            >
                <p style={{ margin: 0, color: "rgb(0, 0, 0)" }}>
                    Điểm xếp hạng hiện tại: <strong>{pointTotal.toLocaleString('vi-VN')}</strong>
                    {currentLevel ? <span style={{ textTransform: "capitalize" }}> • Hạng {currentLevel}</span> : null}
                    {nextLevel ? <span style={{ textTransform: "capitalize" }}> • Hạng kế tiếp {nextLevel}</span> : null}
                </p>
            </div>

            <div
                className="MuiGrid-root styles_rankPoint__eH6Ky MuiGrid-item MuiGrid-grid-xs-12"
                style={{ marginTop: "16px" }}
            />
        </div>
    );
}
